import { leadService } from 'services';

export const FETCH_SUCCESS = 'referrals/FETCH_SUCCESS';
export const FETCH_ERROR = 'referrals/FETCH_ERROR'

export function fetchSuccess(leads){
    return {
        type: FETCH_SUCCESS,
        list: leads
    }
}

export function fetchError(error){
    return {
        type: FETCH_ERROR,
        error: errror
    }
}

export function fetchAll(refId){
    return (dispatch)=>{
        leadService().getReferrals(refId).then((result)=>{
            dispatch(fetchSuccess(result.data))
        }).catch(()=>{
            dispatch(fetchError('Failed to read referrals'))
        });
    }
}

const reducer = (state = {
    list: [],
}, action = {}) => {
  
  switch (action.type) {
    
    case FETCH_SUCCESS:
        return {
            ...state,
            list: [...action.list]
        }

    case FETCH_ERROR:
        return {
            ...state,
            list: []
        }
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// app/modules/referrals.js